require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.array.some");

require("core-js/modules/es.function.name");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.number.to-fixed");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.pad-start");

require("core-js/modules/web.dom-collections.for-each");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.tgjRsaPlatform = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.createAreaDetail = createAreaDetail;
  _exports.energyFeedJson = _exports.riskWarnJson = _exports.rasAreaDetailMap = _exports.rasInfoJson = _exports.rasAreasJson = void 0;
  // mock 数据：塘管家数字化养殖管理中心（新版大屏）
  // 约定：大棚 = 区域（rasArea）；桶 = 大棚下 type=8 的溶氧仪设备（添加一个溶氧仪 = 添加一个桶）
  // 说明：页面在 mock 模式下会直接读写本文件的数据（新增/重命名大棚、增删设备），刷新后还原
  // 设备类型枚举（名称与设计稿一致）
  var RAS_DEVICE_TYPES = [{
    type: 0,
    name: '循环泵'
  }, {
    type: 1,
    name: '蛋白分离器'
  }, {
    type: 2,
    name: '臭氧机'
  }, {
    type: 3,
    name: '氧气锥'
  }, {
    type: 4,
    name: '紫外线杀菌'
  }, {
    type: 5,
    name: '热泵'
  }, {
    type: 6,
    name: '过滤鼓风机'
  }, {
    type: 7,
    name: '微滤机'
  }, {
    type: 8,
    name: '溶氧检测仪'
  }]; // 每个大棚的桶数量（合计 48，对应基地概况的圆桶数量）

  var BARREL_COUNTS = [6, 5, 6, 7, 5, 6, 6, 7]; // 需要告警的桶：[大棚序号, 桶下标(从0开始)]

  var WARN_BARRELS = [[2, 1], [4, 2], [6, 3]];

  function isWarnBarrel(areaId, barrelIndex) {
    return WARN_BARRELS.some(function (item) {
      return item[0] === areaId && item[1] === barrelIndex;
    });
  } // 生成某个大棚的圆桶（溶氧仪）列表


  function buildBarrels(areaId, count) {
    var barrels = [];

    for (var i = 0; i < count; i++) {
      var warn = isWarnBarrel(areaId, i);
      barrels.push({
        type: 8,
        rasAreaId: areaId,
        uniqueId: "".concat(88000000 + areaId * 100 + i + 1),
        name: "".concat(i + 1, "\u53F7\u6876"),
        dissolvedOxygen: warn ? 3.1 : Number((4.8 + (areaId + i) % 4 * 0.3).toFixed(1)),
        depth: warn ? 0.95 : 1.3,
        temperature: 26,
        ph: 7.2,
        minOxygen: 5,
        status: 1,
        warningType: warn ? 1 : 0
      });
    }

    return barrels;
  } // 生成某个大棚的某类设备列表


  function buildDevices(areaId, type, count) {
    var devices = [];

    for (var i = 0; i < count; i++) {
      devices.push({
        type: type,
        rasAreaId: areaId,
        uniqueId: "".concat(type).concat(areaId).concat(String(i + 1).padStart(6, '0')),
        name: "".concat(RAS_DEVICE_TYPES[type].name).concat(i + 1),
        powerRate: type == 0 ? 1.5 : 3,
        workType: i % 2 ? 2 : 1,
        status: 1
      });
    }

    return devices;
  } // 生成设备类型分组（type 0~7 为控制设备、8 为溶氧仪/桶）


  function buildPolicyDevices(areaId, barrelCount) {
    var groups = [];
    [0, 1, 2, 3, 4, 5, 6, 7].forEach(function (type) {
      // 循环泵 2 台全部正常；蛋白分离器 2 台（1 正常 1 异常）；其余各 1 台正常
      var devCount = 1;
      var runningCount = 1;
      var warnCount = 0;

      if (type == 0) {
        devCount = 2;
        runningCount = 2;
      }

      if (type == 1) {
        devCount = 2;
        runningCount = 1;
        warnCount = 1;
      }

      groups.push({
        type: type,
        name: RAS_DEVICE_TYPES[type].name,
        rasAreaId: areaId,
        devCount: devCount,
        runningCount: runningCount,
        waitCount: 0,
        warnCount: warnCount,
        deviceViews: buildDevices(areaId, type, devCount),
        lbDurationSec: 7200,
        lbStatus: 1
      });
    });
    var barrels = buildBarrels(areaId, barrelCount);
    groups.push({
      type: 8,
      name: RAS_DEVICE_TYPES[8].name,
      rasAreaId: areaId,
      devCount: barrels.length,
      runningCount: barrels.length,
      waitCount: 0,
      warnCount: barrels.filter(function (item) {
        return item.warningType > 0;
      }).length,
      deviceViews: barrels
    });
    return groups;
  } // 新建空白大棚的详情分组（无设备、无桶）


  function createAreaDetail(areaId, name) {
    var groups = [0, 1, 2, 3, 4, 5, 6, 7, 8].map(function (type) {
      return {
        type: type,
        name: RAS_DEVICE_TYPES[type].name,
        rasAreaId: areaId,
        devCount: 0,
        runningCount: 0,
        waitCount: 0,
        warnCount: 0,
        deviceViews: [],
        lbDurationSec: 7200,
        lbStatus: 1
      };
    });
    return {
      rasAreaId: areaId,
      name: name || '',
      policyDeviceViews: groups
    };
  } // 大棚列表（= 区域列表）


  var rasAreasJson = BARREL_COUNTS.map(function (count, index) {
    var areaId = index + 1;
    return {
      rasAreaId: areaId,
      name: "".concat(areaId, "\u53F7\u68DA"),
      dissolvedOxygen: Number((4.8 + (areaId + 1) % 4 * 0.3).toFixed(1)),
      temperature: 26,
      ph: 7.2,
      depth: 1.3,
      ryDeviceCount: count,
      ryWarningType: WARN_BARRELS.some(function (item) {
        return item[0] === areaId;
      }) ? 1 : 0
    };
  }); // 大棚详情（key = rasAreaId）

  _exports.rasAreasJson = rasAreasJson;
  var rasAreaDetailMap = {};
  _exports.rasAreaDetailMap = rasAreaDetailMap;
  rasAreasJson.forEach(function (area) {
    rasAreaDetailMap[area.rasAreaId] = {
      rasAreaId: area.rasAreaId,
      name: area.name,
      policyDeviceViews: buildPolicyDevices(area.rasAreaId, BARREL_COUNTS[area.rasAreaId - 1])
    };
  });
  var rasInfoJson = {
    barrels: BARREL_COUNTS.reduce(function (total, count) {
      return total + count;
    }, 0),
    companyName: '测试基地01',
    deviceCount: 83,
    farmingDensity: 60,
    fishType: '加州鲈',
    userId: 88888,
    waterVolume: 1000,
    workerCount: 5
  }; // 风险预警（unread=未读高亮）

  _exports.rasInfoJson = rasInfoJson;
  var riskWarnJson = [{
    key: 'mock-1',
    text: '2号棚2号桶 液位过低',
    time: '9/11 12:21',
    unread: true
  }, {
    key: 'mock-2',
    text: '2号棚蛋白分离器 设备故障',
    time: '9/11 11:56',
    unread: false
  }]; // 底部统计 + 每日投料/用电曲线

  _exports.riskWarnJson = riskWarnJson;
  var energyFeedJson = {
    abnormalBarrelCount: WARN_BARRELS.length,
    todayElectricity: 1211,
    todayFeed: 1392,
    days: Array.from({
      length: 25
    }, function (item, index) {
      return String(index + 1).padStart(2, '0');
    }),
    feedData: [820, 932, 901, 934, 1290, 1330, 1320, 1200, 1109, 1150, 1180, 1090, 960, 1080, 1290, 1350, 1400, 1380, 1300, 1250, 1200, 1350, 1420, 1390, 1392],
    electricityData: [640, 780, 860, 930, 880, 990, 1050, 1080, 960, 890, 920, 980, 1020, 1110, 1180, 1120, 1080, 990, 860, 830, 900, 1020, 1160, 1200, 1211]
  };
  _exports.energyFeedJson = energyFeedJson;
});